import $ from '../_snowpack/pkg/jquery.js';
import L from '../_snowpack/pkg/leaflet.js';
import { Plugins } from '../_snowpack/pkg/@capacitor/core.js';
const { Geolocation } = Plugins;

const Location = {
  marker: null,
  init: function() {
    $('.location').on('click', this.getCurrentPosition.bind(this));
  },
  getCurrentPosition: async function() {
  	$('.blocker').css('display','flex');
  	if(window.innerWidth<700){
			$('.bt-minus').click();
			$('.close-spot').click();	
		}
    try {
      const coordinates = await Geolocation.getCurrentPosition();
      this.setLocationMarker([coordinates.coords.latitude, coordinates.coords.longitude], true);
      this.watchPosition();
      $('.blocker').css('display','none');
    	//$('.location').hide();
    } catch(e) {
      alert(e.message+', please refresh the page to turn on location services');
    	$('.blocker').css('display','none');
    	//$('.location').hide();
    }
  },
  watchPosition: function () {
    Geolocation.watchPosition({}, (position) => {
      if (!position || !position.coords) return;
      this.setLocationMarker([position.coords.latitude, position.coords.longitude]);
    });
  },
  setLocationMarker: function(center, centerTo = false) {
    if (this.marker) {
      this.marker.setLatLng(center).update();
    } else {
      this.marker = L.marker(center, {
        icon: L.icon({
          iconSize: [23,23],
          iconUrl: './assets/icons/location-marker.png'
        })
      });
      this.marker.addTo(map);
    }

    if (centerTo) {
      var latLngs = this.marker.getLatLng();
      //var markerBounds = L.latLngBounds(latLngs);
      map.flyTo(latLngs);
    }
  }
}
export default Location;
